export default __webpack_public_path__ + "static/media/vehicle-info-battery.59285ae6.svg";